import * as React from 'react';
import { StyleSheet, css } from 'aphrodite/no-important';
import { useTheme } from '../../theming/useTheme';
import { hex2rgba } from '../../theming/theming.utils';

const componentConfigThemeKey = 'cardOverlay';

const CardOverlayStyles = (cardOverlayColor: string) => {
  return StyleSheet.create({
    style: {
      width: '100%',
      height: '100%',
      position: 'absolute',
      bottom: '0px',
      background: `linear-gradient(0deg, ${hex2rgba(cardOverlayColor, 0.7)} 0%, rgba(0,0,0,0) 50%)`,
    },
  });
};

interface CardOverlayComponentDataProps { }

interface CardOverlayComponentThemeProps {
  cardOverlayColor: string
}

type CardOverlayComponentProps = CardOverlayComponentDataProps & CardOverlayComponentThemeProps;

export const CardOverlayComponent: React.FunctionComponent<CardOverlayComponentProps> = ({ cardOverlayColor }) => {
  const cardOverlayStyle = CardOverlayStyles(cardOverlayColor);
  return (
    <div className={css(cardOverlayStyle.style)} />
  );
};

const mapThemeProps = (theme: CardOverlayComponentThemeProps): CardOverlayComponentThemeProps => (
  {
    cardOverlayColor: theme.cardOverlayColor,
  }
);

export const CardOverlay = (props: CardOverlayComponentDataProps) => {
  const themeContext = useTheme(mapThemeProps, componentConfigThemeKey);
  return <CardOverlayComponent {...themeContext} {...props} />;
};
